import { render, staticRenderFns } from "./ConfigurationDraftMovement.vue?vue&type=template&id=4bf3884a"
import script from "./ConfigurationDraftMovement.vue?vue&type=script&lang=js"
export * from "./ConfigurationDraftMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports